/**
 * O selo do dia no meio da conversa, como no WhatsApp (SPEC-20261007-1615):
 * "Hoje", "Ontem", o dia da semana para a última semana e a data para o resto.
 * Tudo no fuso de quem olha — o dia é o do relógio da pessoa, não o do servidor.
 */

const DIAS_DA_SEMANA = ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado']

/** Meia-noite local do dia de `data`, em ms — a chave que agrupa as mensagens. */
export function inicioDoDia(data: Date): number {
  return new Date(data.getFullYear(), data.getMonth(), data.getDate()).getTime()
}

/** Dias inteiros entre os dois calendários (não 24h corridas: 23h59 → 0h01 é "ontem"). */
function diasDeDistancia(antes: Date, depois: Date): number {
  // arredonda por causa do horário de verão (dia de 23h ou 25h)
  return Math.round((inicioDoDia(depois) - inicioDoDia(antes)) / 86_400_000)
}

export function rotuloDoDia(data: Date, agora: Date = new Date()): string {
  const dias = diasDeDistancia(data, agora)
  if (dias <= 0) return 'Hoje'
  if (dias === 1) return 'Ontem'
  if (dias < 7) return DIAS_DA_SEMANA[data.getDay()] ?? ''
  const dd = String(data.getDate()).padStart(2, '0')
  const mm = String(data.getMonth() + 1).padStart(2, '0')
  return `${dd}/${mm}/${data.getFullYear()}`
}

/** Esta mensagem abre um dia novo na lista (é a primeira, ou o dia mudou)? */
export function abreDiaNovo(enviadaEm: string, anteriorEm: string | undefined): boolean {
  if (!anteriorEm) return true
  return inicioDoDia(new Date(enviadaEm)) !== inicioDoDia(new Date(anteriorEm))
}
